import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Skeleton, SpecraBadge } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { Link } from 'react-router-dom';
import { useProject } from '../../../hooks/useProjects';
/**
 * The RFI's project team (moved from RfiResponseWorkspacePage for WRT-07; the
 * legacy page imports it from here). `ownedCounts` adds the per-member
 * "Questions owned" count the Team page shows.
 */ export function TeamPanel({ zouProjectId, ownedCounts }) {
    const { data, isLoading, isError } = useProject(zouProjectId);
    const members = data?.members ?? [];
    return /*#__PURE__*/ _jsxs("section", {
        className: "max-w-3xl space-y-2",
        "data-testid": Testids.rfiResponse.teamSection,
        children: [
            ownedCounts ? null : /*#__PURE__*/ _jsx("h2", {
                className: "text-lg font-medium",
                children: "Team"
            }),
            isLoading ? /*#__PURE__*/ _jsx(Skeleton, {
                className: "h-16"
            }) : isError ? /*#__PURE__*/ _jsx("p", {
                className: "text-sm text-destructive",
                role: "alert",
                children: "Couldn't load team members."
            }) : members.length === 0 ? /*#__PURE__*/ _jsx("p", {
                className: "text-sm text-muted-foreground",
                children: "No members yet."
            }) : /*#__PURE__*/ _jsx("ul", {
                className: "divide-y rounded-md border",
                children: members.map((m)=>/*#__PURE__*/ _jsxs("li", {
                        className: "flex items-center justify-between gap-2 px-3 py-2",
                        children: [
                            /*#__PURE__*/ _jsxs("span", {
                                className: "text-sm",
                                children: [
                                    m.name || m.email,
                                    m.name && m.email ? /*#__PURE__*/ _jsxs("span", {
                                        className: "text-muted-foreground",
                                        children: [
                                            " · ",
                                            m.email
                                        ]
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("span", {
                                className: "flex items-center gap-2",
                                children: [
                                    ownedCounts ? /*#__PURE__*/ _jsxs("span", {
                                        className: "text-xs text-muted-foreground",
                                        children: [
                                            ownedCounts.get(m.userId) ?? 0,
                                            " questions owned"
                                        ]
                                    }) : null,
                                    /*#__PURE__*/ _jsx(SpecraBadge, {
                                        variant: "neutral",
                                        children: m.role
                                    })
                                ]
                            })
                        ]
                    }, m.userId))
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "text-xs text-muted-foreground",
                children: "Linked pursuits keep their own teams — linking doesn't add anyone here or there."
            }),
            /*#__PURE__*/ _jsx(Link, {
                className: "text-sm text-primary underline-offset-4 hover:underline",
                to: `/project/${zouProjectId}/team`,
                children: "Manage project members"
            })
        ]
    });
}
